<template>
  <div class="">
    <!-- Header and Add Button -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div class="flex items-center gap-2">
        <!-- material back button -->
        <button @click="goBack" class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 rounded p-1 transition text-white">
          <span class="material-icons text-base">arrow_back</span>
        </button>
        <div>
          <h2 class="text-xl font-semibold text-gray-800">
            {{
              all.length && all[0].categoryGuid.name
                ? `List of posts under ${all[0].categoryGuid.name}`
                : selectedCategory.name
                ? `List of posts under ${selectedCategory.name}`
                : "List of Posts"
            }}
          </h2>
        </div>
      </div>
      <button
        @click="addingNewItem"
        class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white font-semibold px-3 py-2 rounded-lg shadow transition"
      >
        <span class="material-icons text-base">add</span>
        Add Post
      </button>
    </div>
    <!-- Filter Bar -->
    <div class="flex flex-wrap items-center justify-between gap-2 mb-4">
      <div class="flex bg-gray-200 rounded-lg">
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.status === '0' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.status = '0';
            searchData();
          "
        >
          All
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.status === '1' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.status = '1';
            searchData();
          "
        >
          Active
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.status === '2' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.status = '2';
            searchData();
          "
        >
          Inactive
        </button>
      </div>
      <!--  Search and Sort Controls -->
      <div class="flex items-center gap-2">
        <vs-select v-model="search.language" @change="searchData" class="w-28" :color="'#6366f1'">
          <vs-select-item value="all" text="Language" disabled />
          <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
        </vs-select>
        <vs-select v-model="search.sort" @change="searchData" class="w-28" :color="'#6366f1'">
          <vs-select-item value="ASC" text="Ascending" />
          <vs-select-item value="DESC" text="Descending" />
        </vs-select>
        <button
          @click="sortPositions()"
          class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition"
        >
          <span class="material-icons text-base">sort</span> Sort
        </button>
        <button
          @click="resetData()"
          class="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-medium transition"
        >
          <span class="material-icons text-base">refresh</span> Reset
        </button>
      </div>
    </div>
    <!-- Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3"></th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Name</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Description</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Category</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase cursor-pointer" @click="toggleSort('position')">
              Position
              <span v-if="sortColumn === 'position'">
                <span v-if="sortDirection === 'ASC'" class="material-icons text-sm">arrow_upward</span>
                <span v-else class="material-icons text-sm">arrow_downward</span>
              </span>
            </th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Language</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase cursor-pointer" @click="toggleSort('status')">
              Status
              <span v-if="sortColumn === 'status'">
                <span v-if="sortDirection === 'ASC'" class="material-icons text-sm">arrow_upward</span>
                <span v-else class="material-icons text-sm">arrow_downward</span>
              </span>
            </th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase cursor-pointer" @click="toggleSort('shares')">
              Shares
              <span v-if="sortColumn === 'shares'">
                <span v-if="sortDirection === 'ASC'" class="material-icons text-sm">arrow_upward</span>
                <span v-else class="material-icons text-sm">arrow_downward</span>
              </span>
            </th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Tags</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase cursor-pointer" @click="toggleSort('createdAt')">
              Creation Date
              <span v-if="sortColumn === 'createdAt'">
                <span v-if="sortDirection === 'ASC'" class="material-icons text-sm">arrow_upward</span>
                <span v-else class="material-icons text-sm">arrow_downward</span>
              </span>
            </th>
            <th class="px-4 py-3 text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(post, idx) in all" :key="post._id" class="border-b hover:bg-gray-100 transition">
            <td class="px-4 py-1">{{ idx + 1 + (currentPage - 1) * limit }}</td>
            <td class="">
              <img :src="post.image || require('@/assets/images/No-image.png')" class="rounded-md object-cover" style="width: 90px; height: 60px" />
            </td>
            <td class="px-4 py-1 font-medium" style="width: 20%">{{ post.name }}</td>
            <td class="px-4 py-1 text-center">
              <button @click.stop="viewDescription(post.description)" class="focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </button>
            </td>
            <td class="px-4 py-1 text-center">{{ post.categoryGuid.name || "-" }}</td>
            <td class="px-4 py-1 text-center">
              <div class="flex flex-col items-center gap-2">
                <button
                  class="flex items-center justify-center border-2 border-gray-100 rounded-md w-6 h-6 disabled:opacity-50"
                  :disabled="post.position === 1"
                  @click.stop="updatePosition(post._id, search.sort === 'ASC' ? 'up' : 'down', post.categoryGuid._id)"
                >
                  <svg
                    :class="post.position === 1 ? 'text-gray-200' : 'text-gray-400'"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-5 h-5"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 15l-7-7-7 7" />
                  </svg>
                </button>
                <span class="font-semibold">{{ post.position }}</span>
                <button
                  class="flex items-center justify-center border-2 border-gray-100 rounded-md w-6 h-6 disabled:opacity-50"
                  :disabled="post.position === all.length"
                  @click.stop="updatePosition(post._id, search.sort === 'ASC' ? 'down' : 'up', post.categoryGuid._id)"
                >
                  <svg
                    :class="post.position === all.length ? 'text-gray-200' : 'text-gray-400'"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="w-5 h-5"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
            </td>
            <td
              class="px-4 py-1 text-center"
              :title="post.missingLanguages.length > 0 ? `Missing: ${post.missingLanguages.join(', ')}` : 'All languages available'"
            >
              <div class="flex items-center justify-center gap-2">
                {{ post.language }}
                <span
                  v-if="post.languageCount && post.missingLanguages && post.language === 'EN'"
                  :class="[
                    'inline-flex items-center px-2 py-1 rounded-full font-semibold cursor-pointer',
                    post.languageCount - post.missingLanguages.length !== 11 ? 'bg-red-900 text-white' : 'bg-blue-900 text-white',
                  ]"
                >
                  {{ post.languageCount - post.missingLanguages.length }}/{{ post.languageCount }}
                </span>
                <span v-if="post.language === 'EN'" class="material-icons text-gray-400 cursor-pointer" style="font-size: 20px">info</span>
              </div>
            </td>
            <td class="px-4 py-1 text-center">
              <span
                :class="post.status ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-500'"
                class="inline-block px-3 py-1 rounded-full font-semibold"
              >
                {{ post.status ? "Active" : "Inactive" }}
              </span>
            </td>
            <td class="px-4 py-1 text-center font-semibold relative" @click="toggleSharesDropdown(idx)">
              <template>
                <span class="px-2 py-1 rounded-full bg-gray-100 text-gray-600 font-semibold text-center underline cursor-pointer">{{
                  post.totalShares || 0
                }}</span>
                <!-- Dropdown for tags -->
                <div
                  v-if="sharesDropdownIndex === idx"
                  class="absolute left-1/2 z-50 mt-2 w-48 max-w-xs bg-white border border-gray-200 rounded-lg shadow-lg p-2"
                  @click.stop
                >
                  <div class="flex flex-wrap gap-2">
                    <span class="px-2 py-1 rounded-full bg-blue-100 text-blue-600 font-semibold">
                      <img src="@/assets/images/fb.png" class="inline-block w-4 h-4 mr-1" />{{ post.count.facebook || 0 }}
                    </span>
                    <span class="px-2 py-1 rounded-full bg-pink-100 text-pink-600 font-semibold">
                      <img src="@/assets/images/ig.png" class="inline-block w-4 h-4 mr-1" />{{ post.count.instagram || 0 }}
                    </span>
                    <span class="px-2 py-1 rounded-full bg-green-100 text-green-600 font-semibold">
                      <img src="@/assets/images/wa.png" class="inline-block w-4 h-4 mr-1" />{{ post.count.whatsapp || 0 }}
                    </span>
                  </div>
                </div>
              </template>
            </td>
            <td class="px-4 py-1 text-center relative" @click="toggleTagsDropdown(idx)">
              <template v-if="post.tags && post.tags.length">
                <span class="px-2 py-1 rounded-full bg-gray-100 text-gray-600 font-semibold text-center">{{ post.tags[0] }}</span>
                <span v-if="post.tags.length > 1" class="cursor-pointer text-gray-500 ml-1">...</span>
                <!-- Dropdown for tags -->
                <div
                  v-if="tagsDropdownIndex === idx"
                  class="absolute left-1/2 z-50 mt-2 w-48 max-w-xs bg-white border border-gray-200 rounded-lg shadow-lg p-2"
                  @click.stop
                >
                  <div class="flex flex-wrap gap-2">
                    <span v-for="(tag, tIdx) in post.tags" :key="tIdx" class="px-2 py-1 rounded-full bg-gray-100 text-gray-600 font-semibold">{{
                      tag
                    }}</span>
                  </div>
                </div>
              </template>
              <span v-else class="inline-block px-3 py-1 rounded-full bg-gray-100 text-gray-400 font-semibold">-</span>
            </td>
            <td class="px-4 py-1 text-center text-gray-500">{{ formatDate(post.createdAt) || "-" }}</td>
            <td class="px-4 py-1">
              <vs-dropdown>
                <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="1.5" />
                  <circle cx="12" cy="12" r="1.5" />
                  <circle cx="12" cy="19" r="1.5" />
                </svg>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editPost(post)"> <vs-icon icon="create" class="align-right" /> Edit </vs-dropdown-item>
                  <vs-dropdown-item @click="deletePost(post)"> <vs-icon icon="delete_sweep" /> Delete </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
          <tr v-if="!all || all.length === 0">
            <td colspan="13" class="text-center h-full py-6 text-gray-400">No posts found.</td>
          </tr>
        </tbody>
      </table>
      <!-- Pagination -->
      <div class="flex flex-col md:flex-row items-center justify-between mt-3 pr-3">
        <div class="invisible">
          <span>asd</span>
        </div>
        <div class="flex justify-center items-center">
          <vs-pagination v-model="currentPage" :total="totalPages" :limit="1" @change="searchData" class="my-2" />
        </div>
        <div class="flex items-center gap-2 text-sm mt-2 md:mt-0">
          <span>Show Records:</span>
          <vs-select v-model="limit" @change="searchData" class="w-20" :color="'#6366f1'">
            <vs-select-item value="25" text="25" />
            <vs-select-item value="50" text="50" />
            <vs-select-item value="100" text="100" />
          </vs-select>
        </div>
      </div>
    </div>

    <!-- Add/Edit Post Popup -->
    <vs-popup :title="!isEdit ? 'Add New Post' : 'Edit Post'" :active.sync="defaultalert">
      <form @submit.prevent="isEdit ? handleSavePost() : handleUpdatePost()">
        <!-- language filter -->
        <div class="mb-2 px-2 flex justify-between">
          <div class="w-1/4" v-if="isEdit">
            <label class="block text-sm font-semibold mb-2">Language</label>
            <vs-select v-model="post.language" @change="refetchUsingLangugage($event, post)" class="w-full" :color="'#6366f1'" :disabled="showLoader">
              <vs-select-item value="" text="Select Language" disabled />
              <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
            </vs-select>
          </div>
          <div v-if="isEdit && post.language === 'EN'" :title="'Toggle to update existing translations'">
            <!-- toggle pill to update existing translations -->
            <label class="block text-sm font-semibold mb-2">Update Translations</label>
            <toggle-pill v-model="post.translate" :disabled="showLoader" />
          </div>
        </div>
        <div class="px-2">
          <label class="block text-sm font-semibold mb-2">Name</label>
          <vs-input v-model="post.name" placeholder="Enter post name" class="w-full" required />

          <label class="block text-sm font-semibold mb-2 mt-4">Description</label>
          <vs-input v-model="post.description" placeholder="Enter description" class="w-full" required />

          <div class="mb-6 flex flex-col md:flex-row md:items-center md:gap-6 mt-4">
            <div class="flex-1">
              <div class="flex justify-between items-start">
                <label class="block text-sm font-semibold">Image</label>
                <button
                  v-if="displayImage"
                  type="button"
                  color="danger"
                  class="bg-red-500 p-1 h-6 rounded-md hover:bg-red-700 transition text-white"
                  @click="clearImage"
                  :disabled="showLoader"
                >
                  Clear
                </button>
              </div>
              <div
                class="flex flex-col items-center justify-center border-2 border-dashed rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                style="width: 100%; height: 140px; min-height: 140px"
                @dragover.prevent
                @dragenter.prevent
                @drop.prevent="onDropImage"
                @click="triggerFileInput"
              >
                <img
                  v-if="displayImage || post.image"
                  :src="displayImage || post.image"
                  class="rounded-md object-cover border"
                  style="width: 200px; max-height: 140px"
                />
                <div v-else class="flex flex-col items-center justify-center w-full h-full text-gray-400">
                  <span class="material-icons" style="font-size: 32px">cloud_upload</span>
                  <span>Drag & Drop or Click to Upload</span>
                </div>
                <input type="file" ref="fileInput" class="hidden" @change="onImageChange" accept="image/jpeg,image/jpg,image/webp" />
              </div>
            </div>
            <div class="flex-1">
              <label class="block text-sm font-semibold mb-2">Category</label>
              <vs-select v-model="selectedCategory._id" class="w-full mb-4" disabled>
                <vs-select-item v-for="cat in postCategories" :key="cat._id" :value="cat._id" :text="cat.name" />
              </vs-select>
              <label class="block text-sm font-semibold mb-2"
                >Position
                <span v-if="isEdit" class="font-bold">: {{ post.position ? post.position : "Not set" }}</span>
              </label>
              <div class="flex gap-4 mt-2">
                <vs-checkbox v-model="post.moveTop" @change="onMoveTopChange">Move to Top</vs-checkbox>
                <vs-checkbox v-model="post.moveBottom" @change="onMoveBottomChange">Move to Bottom</vs-checkbox>
              </div>
              <vs-checkbox class="pt-2" v-model="post.status">Status (Active / Inactive)</vs-checkbox>
            </div>
          </div>

          <div class="mb-4" style="z-index: 10">
            <label class="block text-sm font-semibold mb-2">Tags</label>
            <Multiselect v-model="post.tags" :options="tags" :track-by="'name'" label="name" :multiple="true" />
          </div>

          <!-- independent language to translate -->
          <div class="mb-4" v-if="!isEdit" style="z-index: 1">
            <label class="block text-sm font-semibold mb-2">Choose Languages to Translate</label>
            <div class="grid grid-cols-7 gap-2">
              <vs-checkbox v-model="selectAllLang" @change="toggleSelectAllLang" :disabled="showLoader" class="z-0">All</vs-checkbox>
              <div v-for="lang in languages" :key="lang.culture">
                <vs-checkbox
                  :value="post.languagesToTranslate.includes(lang.culture)"
                  :disabled="lang.culture === 'EN' || showLoader"
                  @change="toggleLanguage(lang.culture)"
                  class="z-0"
                >
                  {{ lang.culture }}
                </vs-checkbox>
              </div>
            </div>
          </div>

          <!-- add missing languages -->
          <div v-if="isEdit && post.language === 'EN' && post.missingLanguages && post.missingLanguages.length > 0" style="z-index: 1">
            <label class="block text-sm font-semibold pt-1 mb-2">Add missing translations</label>
            <vs-checkbox v-model="post.translateMissing" :disabled="showLoader">Add missing translations</vs-checkbox>
            <div v-if="post.translateMissing" class="grid grid-cols-7 gap-2 mt-3">
              <vs-checkbox v-model="selectAllEdit" @change="toggleSelectAllEdit" :disabled="showLoader" class="z-0">All</vs-checkbox>
              <div v-for="lang in post.missingLanguages" :key="lang">
                <vs-checkbox
                  :value="post.languagesToTranslate.includes(lang) && lang !== 'EN'"
                  :disabled="lang === 'EN' || showLoader"
                  @change="toggleLanguage(lang)"
                  class="z-0"
                >
                  {{ lang }}
                </vs-checkbox>
              </div>
            </div>
          </div>

          <div class="flex flex-col md:flex-row gap-2 mt-8">
            <vs-button
              v-if="isEdit && !post.translateMissing"
              :loading="showLoader"
              color="primary"
              type="filled"
              class="flex-1"
              @click="handleUpdatePost"
              :disabled="showLoader"
            >
              Update current
            </vs-button>
            <vs-button
              v-if="isEdit && post.language === 'EN'"
              :loading="showLoader"
              color="primary"
              type="filled"
              class="flex-1"
              @click="handleUpdateAllPosts"
              :disabled="showLoader"
            >
              {{ post.translateMissing ? "Update And Translate Missing" : "Update All" }}
            </vs-button>
            <vs-button
              v-if="!isEdit"
              :loading="showLoader"
              color="primary"
              type="filled"
              class="flex-1"
              @click="handleSavePost"
              :disabled="showLoader"
            >
              {{ post.languagesToTranslate.length > 1 ? "Save and Translate" : "Save English" }}
            </vs-button>
          </div>
        </div>
      </form>
    </vs-popup>

    <!-- Delete Confirmation Popup -->
    <vs-popup title="Delete Post" :active.sync="deletePostPopup">
      <p class="mb-4 text-lg">Are you sure you want to delete this post?</p>
      <div class="flex justify-end gap-2">
        <vs-button color="warning" @click="confirmDeletePost">Delete</vs-button>
        <vs-button color="primary" @click="deletePostPopup = false">Cancel</vs-button>
      </div>
    </vs-popup>

    <!-- Description Popup -->
    <vs-popup title="Post Description" :active.sync="descriptionPopup" width="600px">
      <p class="text-gray-700">{{ postDescription }}</p>
      <div class="flex justify-end">
        <vs-button color="primary" @click="descriptionPopup = false">Close</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import moment from "moment";
import Multiselect from "vue-multiselect";
import TogglePill from "../components/Common/TogglePill.vue";

export default {
  name: "DailyStatus",
  components: {
    Multiselect,
    TogglePill,
  },
  data() {
    return {
      search: {
        sort: "ASC",
        language: "EN",
        status: "0",
      },
      languages: [],
      all: [],
      tags: [],
      currentPage: 1,
      limit: 25,
      totalPages: 0,
      selectAllLang: false,
      selectAllEdit: false,
      isEdit: false,
      deletePostPopup: false,
      postDescription: "",
      descriptionPopup: false,
      itemToDelete: null,
      tagsDropdownIndex: null,
      sharesDropdownIndex: null,
      postLanguages: [],
      selectedCategory: {
        _id: "",
        name: "",
      },
      post: {
        missingLanguages: [],
        languagesToTranslate: ["EN"],
        name: "",
        description: "",
        status: true,
        language: "",
        position: "",
        image: "",
        categoryObject: {},
        count: {
          facebook: 0,
          whatsapp: 0,
          instagram: 0,
        },
        tags: [],
        moveTop: false,
        moveBottom: false,
        translate: false,
        translateMissing: false,
      },
      defaultalert: false,
      displayImage: "",
      postCategories: [],
      showLoader: false,
      sortColumn: null, // Track the column being sorted
      sortDirection: null, // Track the sorting direction
    };
  },
  methods: {
    goBack() {
      this.$router.push("/daily-status");
    },
    onMoveTopChange() {
      if (this.post.moveTop) {
        this.post.moveBottom = false;
      } else if (!this.post.moveBottom) {
        this.post.moveBottom = true;
      }
    },
    onMoveBottomChange() {
      if (this.post.moveBottom) {
        this.post.moveTop = false;
      } else if (!this.post.moveTop) {
        this.post.moveBottom = true;
      }
    },

    toggleSharesDropdown(idx) {
      if (this.sharesDropdownIndex === idx) {
        this.sharesDropdownIndex = null;
      } else {
        this.sharesDropdownIndex = idx;
      }
    },

    toggleSelectAllLang() {
      if (this.selectAllLang) {
        this.post.languagesToTranslate = this.languages.map((lang) => lang.culture);
      } else {
        this.post.languagesToTranslate = ["EN"];
      }
    },

    toggleSelectAllEdit() {
      if (this.selectAllEdit) {
        this.post.languagesToTranslate = this.post.missingLanguages;
      } else {
        this.post.languagesToTranslate = ["EN"];
      }
    },

    toggleLanguage(culture) {
      const selectedLanguages = this.post.languagesToTranslate;

      if (selectedLanguages.includes(culture)) {
        this.post.languagesToTranslate = selectedLanguages.filter((lang) => lang !== culture);
      } else {
        this.post.languagesToTranslate = [...selectedLanguages, culture];
      }

      const allLanguagesSelected = this.languages.every((lang) => this.post.languagesToTranslate.includes(lang.culture));
      this.selectAllLang = allLanguagesSelected;
      if (this.selectAllEdit) {
        const allLanguagesSelected = this.post.missingLanguages.every((lang) => this.post.languagesToTranslate.includes(lang));
        this.selectAllEdit = allLanguagesSelected;
      }
      console.log(this.post.languagesToTranslate);
    },

    viewDescription(description) {
      this.postDescription = description;
      this.descriptionPopup = true;
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "EN",
        status: "0",
      };
      this.$data.limit = 25;
      this.searchData();
    },

    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.post.image = file;
        this.displayImage = URL.createObjectURL(file);
      }
    },

    clearImage() {
      this.displayImage = "";
      this.post.image = "";
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
    },

    triggerFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },

    onDropImage(e) {
      const files = e.dataTransfer.files;
      if (files && files[0]) {
        this.onImageChange({ target: { files } });
      }
    },

    async addingNewItem() {
      await this.fetchActiveCategoriesByLanguage("EN");
      this.clearImage();
      this.$data.defaultalert = true;
      this.$data.isEdit = false;
      this.$data.displayImage = "";
      this.$data.post = {
        missingLanguages: [],
        languagesToTranslate: ["EN"],
        name: "",
        description: "",
        status: true,
        count: {
          facebook: 0,
          whatsapp: 0,
          instagram: 0,
        },
        image: "",
        categoryObject: {},
        tags: [],
        language: "EN",
        position: "",
        moveBottom: true,
        moveTop: false,
        translate: false,
      };
      if (this.$route.query.fromSelection === "true") {
        const queryParams = { ...this.$route.query };
        delete queryParams.fromSelection;
        this.$router.replace({ query: queryParams });
      }
    },

    editPost(post) {
      this.fetchActiveCategoriesByLanguage(post.language);
      this.$data.isEdit = true;
      this.$data.post = { ...post };
      this.$data.selectedCategory = {
        _id: post.categoryGuid._id,
        name: post.categoryGuid.name,
      };
      this.$data.post.languagesToTranslate = post.languagesToTranslate || ["EN"];
      this.$data.displayImage = post.image || "";
      if (post.tags) {
        this.$data.post.tags = post.tags.map((tag) => {
          return this.tags.find((t) => t.name === tag) || { name: tag };
        });
      }
      this.$data.defaultalert = true;
    },

    deletePost(post) {
      this.$data.deletePostPopup = true;
      this.$data.itemToDelete = post;
    },

    async confirmDeletePost() {
      this.$vs.loading();
      try {
        const response = await api.delete(`${API.DELETE_POST}/${this.$data.itemToDelete._id}`);
        if (response.status === 200) {
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });

          this.$data.deletePostPopup = false;
          this.$data.all = this.$data.all.filter((x) => x._id !== this.$data.itemToDelete._id);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error in Deleting Data",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchActiveCategoriesByLanguage(lang) {
      if (this.postCategories.length > 0) return;

      this.$vs.loading();
      this.$data.postCategories = [];
      try {
        const r = await api.get(`${API.GET_ACTIVE_CATEGORY_BY_LANGUAGE}?language=${lang}`);
        this.$vs.loading.close();
        if (r.status === 200) {
          this.$data.postCategories = r.data.data;
          const prefill = this.$data.postCategories.find((x) => x._id === this.$route.query.category);
          if (prefill) {
            this.selectedCategory = {
              _id: prefill._id,
              name: prefill.name,
            };
            this.$data.post.categoryObject = { ...prefill };
          }
        }
      } catch (error) {
        this.$data.category = "";
        this.$vs.notify({
          title: "Error",
          text: "Failed to fetch categories.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async sortPositions() {
      this.$vs.loading();
      const catId = this.$route.query.category;

      try {
        const res = await api.put(`${API.POST_SORT_POSITION}?language=${this.$data.search.language}&cat=${catId}`, {});
        if (res.status === 200) {
          this.$vs.notify({
            text: "Sorted Successfully",
            color: "success",
            position: "top-right",
          });
          await this.searchData();
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error.response.data.error || "An error occurred while sorting.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async getAllTags() {
      try {
        const response = await api.get(`${API.GET_TAG}?language=${this.search.language}`);
        if (response.status === 200) {
          this.tags = response.data;
          this.post.tags = this.post.tags.map((tag) => {
            return this.tags.find((t) => t.name === tag) || { name: tag };
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Failed to fetch tags. Please try again later.",
          color: "danger",
        });
      }
    },

    async searchData() {
      try {
        const response = await api.get(
          `${API.SEARCH_POST}?categoryGuid=${this.$route.query.category}&language=${this.$data.search.language}&status=${this.search.status}&sort=${this.search.sort}&page=${this.currentPage}&limit=${this.limit}`
        );
        if (response.status === 200) {
          this.all = response.data.data;
          this.totalPages = Math.ceil(response.data.totalNumber / this.limit);
          if (this.all.length === 0) {
            this.selectedCategory = { _id: this.$route.query.category, name: this.$route.query.catName || "Unknown category" };
          }
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Failed to fetch posts. Please try again later.",
          color: "danger",
        });
      }
    },

    async fetchAllLanguages() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_LANG, {});
        this.languages = r.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching languages.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    toggleTagsDropdown(idx) {
      this.tagsDropdownIndex = this.tagsDropdownIndex === idx ? null : idx;
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.tagsDropdownIndex = null;
      }
    },

    async updatePosition(itemId, type, catId) {
      try {
        this.$vs.loading();

        const r = await api.put(`${API.POST_UPDATE_POSITION}/${itemId}?direction=${type}&cat=${catId}`, {});
        if (r.status === 200) {
          this.$vs.notify({
            text: "Position Updated Successfully",
            color: "success",
            position: "top-right",
          });
          await this.searchData();
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async handleSavePost() {
      const data = { ...this.post };

      if (!data.name || !data.description || !data.language || !data.categoryObject || !data.image) {
        this.$vs.notify({
          title: "Error",
          text: "Please fill all details.",
          color: "danger",
          position: "top-right",
        });
        return (this.showLoader = false);
      }

      let imageUrl = "";

      if (this.post.image instanceof File) {
        let formdata = new FormData();
        formdata.append("category", this.post.name);
        formdata.append("file", this.post.image);
        this.$vs.loading();
        try {
          const response = await api.post(API.UPLOAD_IMAGE, formdata, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
            return;
          } else {
            imageUrl = response.data.files[0].url;
          }
        } catch (e) {
          this.$vs.loading.close();
          this.$vs.notify({
            text: "File Uploading Failed",
            color: "danger",
            position: "top-right",
          });
          return;
        }
        this.$vs.loading.close();
      } else {
        imageUrl = this.post.image;
      }

      data.categoryObject = this.postCategories.find((c) => c._id === this.selectedCategory._id) || {};
      data.image = imageUrl;
      data.categoryGuid = data.categoryObject._id;
      data.tags = data.tags.map((tag) => tag.name);

      this.showLoader = this.post.languagesToTranslate.length > 1;
      try {
        let res;

        if (this.post.languagesToTranslate.length > 1) {
          data.languagesToTranslate = this.post.languagesToTranslate;
          res = await api.post(API.C_AND_T_POST, data);
        } else {
          delete data.languagesToTranslate;
          res = await api.post(API.INSERT_POST, data);
        }

        if (res.status === 200) {
          this.$vs.notify({
            text: this.post.languagesToTranslate.length > 1 ? "Post saved and translations started." : "Post saved.",
            color: "success",
            position: "top-right",
          });
          this.defaultalert = false;
          this.searchData();
          this.clearImage();
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error.response.data.error || "An error occurred while adding the post.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.showLoader = false;
      }
    },

    async handleUpdatePost() {
      const data = { ...this.post };

      if (!data.name || !data.description || !data.language || !data.categoryObject || !data.image) {
        this.$vs.notify({
          title: "Error",
          text: "Please fill all details.",
          color: "danger",
          position: "top-right",
        });
        return (this.showLoader = false);
      }

      let imageUrl = "";

      if (this.post.image instanceof File) {
        let formdata = new FormData();
        formdata.append("category", this.post.name);
        formdata.append("file", this.post.image);
        this.$vs.loading();
        try {
          const response = await api.post(API.UPLOAD_IMAGE, formdata, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
            return;
          } else {
            imageUrl = response.data.files[0].url;
          }
        } catch (e) {
          this.$vs.loading.close();
          this.$vs.notify({
            text: "File Uploading Failed",
            color: "danger",
            position: "top-right",
          });
          return;
        }
        this.$vs.loading.close();
      } else {
        imageUrl = this.post.image;
      }

      data.categoryObject = this.postCategories.find((c) => c._id === this.selectedCategory._id) || {};
      data.image = imageUrl;
      data.categoryGuid = data.categoryObject._id;
      data.tags = data.tags.map((tag) => {
        if (tag._id) return tag.name;
      });

      this.showLoader = this.post.languagesToTranslate.length > 1;
      try {
        const response = await api.put(`${API.UPDATE_POST}/${this.post._id}`, data);
        if (response.status === 200) {
          this.$vs.notify({
            text: "Post updated successfully.",
            color: "success",
            position: "top-right",
          });
          this.defaultalert = false;
          this.searchData();
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error.response.data.error || "An error occurred while updating the post.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.showLoader = false;
      }
    },

    async handleUpdateAllPosts() {
      const data = { ...this.post };

      try {
        this.$data.showLoader = true;

        let imageUrl = "";

        if (this.post.image instanceof File) {
          let formdata = new FormData();
          formdata.append("category", this.post.name);
          formdata.append("file", this.post.image);
          this.$vs.loading();
          try {
            const response = await api.post(API.UPLOAD_IMAGE, formdata, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            if (response.data.error != null) {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Uploading Error",
                text: response.data.error.message,
                color: "danger",
                position: "top-right",
              });
              return;
            } else {
              imageUrl = response.data.files[0].url;
            }
          } catch (e) {
            this.$vs.loading.close();
            this.$vs.notify({
              text: "File Uploading Failed",
              color: "danger",
              position: "top-right",
            });
            return;
          }
          this.$vs.loading.close();
        } else {
          imageUrl = data.image;
        }

        data.categoryObject = this.postCategories.find((c) => c._id === this.selectedCategory._id) || {};
        data.image = imageUrl;
        data.categoryGuid = data.categoryObject._id;
        data.tags = data.tags.map((tag) => {
          if (tag._id) return tag.name;
        });

        data.translate = this.$data.post.translate ? true : false;

        const res = await api.put(`${API.U_AND_T_POST}/${this.$data.post._id}`, data);
        if (res.status === 200) {
          this.$vs.notify({
            text: "Saved Successfully",
            color: "success",
            position: "top-right",
          });

          this.defaultalert = false;
          this.searchData();
          if (res.data.extraMessages.length > 0) {
            for (const message of res.data.extraMessages) {
              this.$vs.notify({
                text: message + "post not translated",
                color: "warning",
                position: "top-right",
              });
            }
          }

          this.searchData();
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
        this.$data.showLoader = false;
      }
    },

    async refetchUsingLangugage(lang, post) {
      const storepost = { ...post };
      storepost.language = "EN";

      try {
        let id = post.ref || post._id;
        if (!id) return;
        this.$vs.loading();

        const res = await api.get(`${API.GET_SINGLE_POST}/${id}?language=${lang}`);

        if (res.status === 200) {
          this.$data.post = { ...res.data };
          this.$data.selectedCategory = {
            _id: res.data.categoryGuid._id,
            name: res.data.categoryGuid.name,
          };
          this.$data.displayImage = res.data.image;
          this.$data.post.language = res.data.language;

          const missingLanguages = this.$data.all.find((x) => x._id === id).missingLanguages || [];
          this.$data.post.missingLanguages = missingLanguages;
          this.$data.post.languagesToTranslate = [];

          await Promise.all([this.fetchActiveCategoriesByLanguage(lang), this.getAllTags(lang)]);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Translation Not Found or Localised Category Not Exist",
          color: "danger",
          position: "top-right",
        });

        this.$data.post = { ...storepost };
      } finally {
        this.$vs.loading.close();
      }
    },

    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === "ASC" ? "DESC" : "ASC";
      } else {
        this.sortColumn = column;
        this.sortDirection = "ASC";
      }

      this.all.sort((a, b) => {
        let valA = a[column];
        let valB = b[column];

        if (column === "shares") {
          valA = a.totalShares || 0;
          valB = b.totalShares || 0;
        }

        if (typeof valA === "string" && typeof valB === "string") {
          valA = valA.toLowerCase();
          valB = valB.toLowerCase();
        }

        if (this.sortDirection === "ASC") {
          return valA > valB ? 1 : valA < valB ? -1 : 0;
        } else {
          return valA < valB ? 1 : valA > valB ? -1 : 0;
        }
      });
    },
  },
  async mounted() {
    this.$data.search.language = this.$route.query.catLang || "EN";
    document.addEventListener("click", this.handleClickOutside);
    await Promise.all[(this.getAllTags(), this.searchData(), this.fetchAllLanguages())];
    if (this.$route.query.fromSelection === "true") this.addingNewItem();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style>
